<template>
  <v-layout column>
    <v-layout :column="$vuetify.breakpoint.xs">
      <v-flex>
        <v-layout column>
          <div>
            <checkbox
              v-if="!isEvent6422"
              v-model="form.privateReceipt"
              :disabled="hideR1Invoice"
              @input="form.r1Invoice = !form.r1Invoice"
            >
              {{ $t('privateReceipt') }}
            </checkbox>
          </div>
          <div>
            <checkbox
              v-if="!hideR1Invoice"
              v-model="form.r1Invoice"
              :disabled="isEvent6422"
              @input="form.privateReceipt = !form.privateReceipt"
            >
              {{ $t('r1Invoice') }}
            </checkbox>
          </div>
          <div v-if="form.r1Invoice && !hideR1Invoice">
            <text-field
              v-model.trim="form.legalEntityName"
              class="pb-16"
              :label="$t('legalEntityName')"
              type="text"
              :validator="vs.form.legalEntityName"
            />
            <div class="pb-16 r1-row">
              <text-field
                v-model.trim="form.legalEntityAddress"
                :label="$t('addressLabel')"
                type="text"
                :validator="vs.form.legalEntityAddress"
              />
              <text-field
                v-model="form.legalEntityZipcode"
                :label="$t('zipCode')"
                type="number"
                :validator="vs.form.legalEntityZipcode"
              />
            </div>
            <div class="pb-16 r1-row">
              <text-field
                v-model.trim="form.legalEntityCity"
                :label="$t('city')"
                type="text"
                :validator="vs.form.legalEntityCity"
              />
              <v-autocomplete
                v-model="form.legalEntityCountry"
                outline
                class="select-r1-country"
                :items="countries"
                item-text="common"
                item-value="common"
                :label="$t('country')"
                :validator="vs.form.legalEntityCountry"
                :return-object="false"
              />
            </div>
            <text-field
              v-model="form.legalEntityOIB"
              class="pb-16"
              :label="$t('legalEntityVatNumber')"
              type="text"
              :error-messages="{
                validVatNumberFormat: $t('legalEntityVatNumberFormatInvalid'),
                validVatNumber: $t('legalEntityVatNumberInvalid'),
              }"
              :validator="vs.form.legalEntityOIB"
            />
            <text-field
              v-model="form.legalEntityEmail"
              class="pb-16"
              label="Email*"
              type="email"
              :validator="vs.form.legalEntityEmail"
            />
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
const countries = require('../../assets/countries')
export default {
  name: 'receipt-form',
  props: {
    eventId: {
      type: [Number, String],
      default: null,
    },
    disableR1Invoice: {
      type: Boolean,
      default: false,
    },
    vs: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        privateReceipt: true,
        r1Invoice: false,
        legalEntityCountry: 'Croatia',
      },
      countries,
    }
  },
  computed: {
    numericEventId() {
      return this.eventId == null ? null : Number(this.eventId)
    },
    hideR1Invoice() {
      return [6421, 6627].includes(this.numericEventId)
    },
    isEvent6422() {
      return this.numericEventId === 6422
    },
  },
  watch: {
    eventId: {
      handler() {
        this.applySimpleEventDefaults()
      },
      immediate: true,
    },
    disableR1Invoice: {
      handler(newVal) {
        if (newVal) {
          // existing behavior: gift card disables R1
          this.form.r1Invoice = false
          this.form.privateReceipt = true
        } else {
          // when re-enabled, re-apply event defaults
          this.applySimpleEventDefaults()
        }
      },
      immediate: true,
    },
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  methods: {
    applySimpleEventDefaults() {
      if (this.disableR1Invoice) return

      // 6421/6627: remove R1 option (private only)
      if (this.hideR1Invoice) {
        this.form.r1Invoice = false
        this.form.privateReceipt = true
      }

      // 6422: remove private option + auto-select R1 so fields show
      if (this.isEvent6422) {
        this.form.privateReceipt = false
        this.form.r1Invoice = true
        this.$nextTick(() => {
          this.$emit('values', { ...this.form })
        })
      }
    },
  },
}
</script>

<style>
.r1-row {
  display: flex;
  column-gap: 1.5rem;
  flex-wrap: wrap;
}
.r1-row .v-input__append-inner {
  margin-left: -24px !important;
}
.r1-row .v-input__slot {
  height: 56px;
  border: 1px solid #d9d9d9 !important;
}
</style>
